module.exports = __webpack_public_path__ + "img/first-bg.65d7c2dc.webp";